export default class YMetrika {
    constructor() {
        this.client = null;
    }

    /**
     * @param {Function} callback
     * @private
     */
    _executeWithClient(callback) {
        if (this.client == null) {
            for (var i in window) {
                if (new RegExp(/yaCounter/).test(i)) {
                    this.client = window[i];
                    break;
                }
            }
        }
        if (this.client != null) {
            try {
                callback(this.client);
            } catch (e) {
                /*ok */
            }
        }
    }

    hitUrl(url) {
        this._executeWithClient(client => client.hit(url));
    }
}

